export default "__VITE_ASSET__DarlFSQ2__"